import { Flex, Skeleton } from '@percent/lemonade'

export function ProfileCreationSkeleton({ withPreferredNameField }: { withPreferredNameField: boolean }) {
  return (
    <>
      <Flex direction="column" gap={8}>
        <Skeleton variant="rectangular" width="30%" height={21} />
        <Skeleton variant="rectangular" width="100%" height={40} />
        <Skeleton variant="rectangular" width="70%" height={21} />
      </Flex>
      {withPreferredNameField && (
        <Flex direction="column" gap={8}>
          <Skeleton variant="rectangular" width="50%" height={21} />
          <Skeleton variant="rectangular" width="100%" height={40} />
          <Skeleton variant="rectangular" width="60%" height={21} />
        </Flex>
      )}
      <Flex direction="column" gap={8}>
        <Skeleton variant="rectangular" width="60%" height={21} />
        <Skeleton variant="rectangular" width="100%" height={40} />
        <Skeleton variant="rectangular" width="100%" height={21} />
      </Flex>
      <div style={{ height: '1px', width: '100%', backgroundColor: '#e5e7eb' }} />
      <Skeleton variant="rectangular" width="100%" height={48} />
      <Flex direction="row" align="flex-start" gap={12}>
        <Skeleton variant="rectangular" width={20} height={20} />
        <Skeleton variant="rectangular" width="calc(100% - 32px)" height={40} />
      </Flex>
      <Flex direction="column" gap={8} style={{ marginTop: '24px' }}>
        <Skeleton variant="rectangular" width="100%" height={40} style={{ borderRadius: '4px' }} />
      </Flex>
    </>
  )
}
